module.exports = __webpack_public_path__ + "img/p7.c31a8715.png";